module.exports = __webpack_public_path__ + "images/095d26408161f182cbc4516f7156e287-Resorts World Las Vegas.jpg";